module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [_vm._v("\n    w:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.width),
      expression: "width"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.width = $event.target.value
      }
    }
  }), _vm._v("\n    h:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.height),
      expression: "height"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.height = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.init()
      }
    }
  }, [_vm._v("init")])]), _vm._v(" "), _c('div', [_vm._v("\n    step:\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.count),
      expression: "count"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.count)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.count = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.execute()
      }
    }
  }, [_vm._v("execute")])]), _vm._v(" "), _c('table', _vm._l((_vm.cells), function(line) {
    return _c('tr', _vm._l((line), function(cell) {
      return _c('td', [_c('div', {
        staticClass: "cell",
        style: (cell.getStyle())
      })])
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ceac49a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 31
// module chunks = 1